import React from 'react';
import { Handshake, Trophy, FileSignature, Users2, Sparkles } from 'lucide-react';
import { partnerships, achievements } from '../utils/mock';

const typeIcons = {
  "MoU Signed": FileSignature,
  "Partnership": Handshake,
  "Collaboration": Users2
};

const Partnerships = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6" data-testid="partnerships-page-title">
            Partnerships & <span className="text-cyan-400">Achievements</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Building strong collaborations and earning recognition on our journey to empower young innovators.
          </p>
        </div>
      </section>

      {/* Partnerships */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-3 mb-10">
            <Handshake className="text-cyan-400" size={30} />
            <h2 className="text-3xl font-bold text-white">Our Partnerships</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-testid="partnerships-grid">
            {partnerships.map((p) => {
              const Icon = typeIcons[p.type] || Handshake;
              return (
                <div
                  key={p.id}
                  data-testid={`partnership-card-${p.id}`}
                  className="bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950/50 backdrop-blur-sm border border-cyan-500/20 rounded-2xl p-8 hover:border-cyan-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/20"
                >
                  <div className="w-14 h-14 bg-cyan-500/15 border border-cyan-500/30 rounded-xl flex items-center justify-center mb-5">
                    <Icon className="text-cyan-400" size={26} />
                  </div>
                  <span className="inline-block px-3 py-1 bg-cyan-500/10 border border-cyan-500/30 rounded-full text-cyan-400 text-xs font-medium mb-4">
                    {p.type}
                  </span>
                  <h3 className="text-xl font-bold text-white mb-3">{p.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">{p.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Achievements */}
      <section className="py-12 pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-3 mb-10">
            <Trophy className="text-cyan-400" size={30} />
            <h2 className="text-3xl font-bold text-white">Our Achievements</h2>
          </div>
          <div className="space-y-8" data-testid="achievements-list">
            {achievements.map((a) => (
              <div
                key={a.id}
                data-testid={`achievement-card-${a.id}`}
                className="relative overflow-hidden bg-gradient-to-br from-cyan-500/10 to-blue-500/10 backdrop-blur-sm border border-cyan-500/30 rounded-2xl p-10 hover:border-cyan-500/60 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/20"
              >
                <div className="absolute top-0 right-0 w-64 h-64 bg-cyan-500/10 rounded-full blur-3xl"></div>
                <div className="relative flex flex-col md:flex-row md:items-center gap-6">
                  <div className="flex-shrink-0 w-20 h-20 bg-cyan-500/15 border border-cyan-500/40 rounded-2xl flex items-center justify-center">
                    <Trophy className="text-cyan-400" size={38} />
                  </div>
                  <div>
                    <div className="flex items-center space-x-2 text-cyan-400 text-sm font-medium mb-2">
                      <Sparkles size={16} />
                      <span>Proud Milestone</span>
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-3">{a.title}</h3>
                    <p className="text-gray-300 leading-relaxed">{a.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Partnerships;
